import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sample-card-general',
  templateUrl: './sample-card-general.component.html',
  styleUrls: ['./sample-card-general.component.scss']
})
export class SampleCardGeneralComponent implements OnInit {

  @Input() block: any;

  constructor() { }

  ngOnInit(): void { }

}
